import React from 'react';
import { LAYOUT } from '../Layout/enums';
import './styles.css';


function AccountNumberInformation(props) {
  const { layout } = props;
  let styleSuff = '';
  switch (layout) {
    case LAYOUT.TAB:
      styleSuff = 'Tab';
      break;
    case LAYOUT.MOB:
      styleSuff = 'Mob';
      break;
    // no default
  }
  return (
    <div styleName={`formGroup${styleSuff}`}>
      <div styleName={`labelBlack${styleSuff}`}>Account Information</div>
      <div styleName="formFields">
        <div styleName="labelGrey">Account Number</div>
        <div styleName="labelGrey">{props.accountNumber}</div>
      </div>
    </div>
  );
}

export default AccountNumberInformation;



// WEBPACK FOOTER //
// ./src/components/ManageAccount/AccountNumberInformation.js